import {
  Button,
  Flex,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Text,
} from '@chakra-ui/react';
import { CompetitivenessLevel } from '@client/graphql/__generated__/types';

enum CompToggle {
  NOT_COMPETITIVE = 'NOT_COMPETITIVE',
  COMPETITIVE = 'COMPETITIVE',
}

const DETAILS_TEXT = {
  [CompToggle.NOT_COMPETITIVE]: [
    'Seller will not view favorably',
    'Seller will likely counter key terms',
    'Good starting point for negotiations',
    'Strong offer with great terms',
  ],
  [CompToggle.COMPETITIVE]: [
    'Seller will not view favorably',
    'Will struggle against strong offers',
    'Decent but may not stand out',
    'Seller will strongly consider',
  ],
};

export const OfferScoreDetailsPopover = ({
  competitiveness,
}: {
  competitiveness?: CompetitivenessLevel;
}) => {
  const toggle =
    !competitiveness ||
    competitiveness === CompetitivenessLevel.UNKNOWN ||
    competitiveness === CompetitivenessLevel.NOT_COMPETITIVE_AT_ALL ||
    competitiveness === CompetitivenessLevel.NOT_COMPETITIVE
      ? CompToggle.NOT_COMPETITIVE
      : CompToggle.COMPETITIVE;

  const texts = DETAILS_TEXT[toggle];

  return (
    <Popover>
      <PopoverTrigger>
        <Button color="whiteAlpha.600" textAlign="center" variant="link">
          Details
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent bg="bg.mainDark" p={2} width="380px">
          <PopoverCloseButton />
          <PopoverHeader>
            <Text
              color="whiteAlpha.600"
              fontSize="sm"
              fontWeight="medium"
              textTransform="uppercase"
            >
              Offer Score Definitions
            </Text>
          </PopoverHeader>
          <PopoverBody>
            <Flex direction="column" gap={2}>
              <Flex alignItems="center" gap={7}>
                <Text
                  color="red.400"
                  fontSize="32px"
                  fontWeight="medium"
                  whiteSpace="nowrap"
                >
                  1-3
                </Text>
                <Text fontWeight="medium">{texts[0]}</Text>
              </Flex>
              <Flex alignItems="center" gap={6}>
                <Text
                  color="orange.400"
                  fontSize="32px"
                  fontWeight="medium"
                  whiteSpace="nowrap"
                >
                  4-5
                </Text>
                <Text fontWeight="medium">{texts[1]}</Text>
              </Flex>
              <Flex alignItems="center" gap={7}>
                <Text
                  color="yellow.400"
                  fontSize="32px"
                  fontWeight="medium"
                  whiteSpace="nowrap"
                >
                  6-7
                </Text>
                <Text fontWeight="medium">{texts[2]}</Text>
              </Flex>
              <Flex alignItems="center" gap={4}>
                <Text
                  color="green.400"
                  fontSize="32px"
                  fontWeight="medium"
                  whiteSpace="nowrap"
                >
                  8-10
                </Text>
                <Text fontWeight="medium">{texts[3]}</Text>
              </Flex>
            </Flex>
          </PopoverBody>
          <PopoverFooter>
            <Text fontSize="sm">
              Offer Score shows how attractive your offer looks to sellers
              according to expert agents, not your likelihood of acceptance
            </Text>
          </PopoverFooter>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
